import { Form, Switch } from 'antd';
import styles from './member-modal.module.scss';

/** Một dòng công tắc: nhãn + mô tả bên trái, Switch bên phải. */
export default function ToggleRow({ name, label, hint }: { name: string; label: string; hint: string }) {
  return (
    <div className={styles.toggleRow}>
      <div className={styles.toggleText}>
        <div className={styles.toggleLabel}>{label}</div>
        <div className={styles.hint}>{hint}</div>
      </div>
      <Form.Item name={name} valuePropName="checked" noStyle>
        <Switch aria-label={label} />
      </Form.Item>
    </div>
  );
}
